import styled from "styled-components";

export const Wrapper = styled.div`
  width: 60%;
  .fixedButton {
    position: fixed;
    bottom: 0px;
    right: 0px;
    padding: 20px;
    z-index: 50;
  }

  @media (min-width: 2000px) {
    .fixedButton {
      right: calc((100vw - 2000px) / 2);
    }
  }
  .roundedFixedBtn {
    height: 60px;
    line-height: 80px;
    width: 60px;
    font-size: 2em;
    font-weight: bold;
    border-radius: 50%;
    color: white;
    text-align: center;
    cursor: pointer;
  }
`;

export const ChatMessageWindowWrapper = styled.div`
  height: 100%;
  scroll-behavior: smooth;
  position: relative;
  .button-container {
    background: ${(props) => props.theme?.gradientButton?.background};
    border: none;
    outline: none;
    color: ${(props) => props.theme?.gradientButton?.text};
    border-radius: 30px;
    padding: 1em 3em;
    width: 30px;
  }
  /* width */
  *::-webkit-scrollbar {
    width: 5px;
  }
  /* Track */
  *::-webkit-scrollbar-track {
    background: ${(props) => props.theme?.whitecolor};
    border-radius: 11px;
  }

  /* Handle */
  *::-webkit-scrollbar-thumb {
    background: ${(props) => props.theme?.primarycolor};
    border-radius: 11px;
  }
`;
